import createApp from './main';
import { getClientPageData } from '../../utils/dom';

import '@rei/cedar/dist/reset.css';
import '@rei/cedar/dist/cdr-fonts.css';
import '@rei/cedar/dist/style/cdr-container.css';
import '@rei/cedar/dist/style/cdr-grid.css';
import '@rei/cedar/dist/style/cdr-breadcrumb.css';
import '@rei/cedar/dist/style/cdr-text.css';
import '@rei/cedar/dist/style/cdr-link.css';

const initMetrics = () => {
  if (typeof window !== 'undefined' && window.metrics) {
    const siteId = 'opo';
    const contentType = 'non-commerce';
    const templateType = 'outdoor school';
    const pageDescription = 'All Places';
    const payload = {
      pageName: `${siteId}:${templateType}_${pageDescription}`,
      siteId,
      templateType,
      contentType,
      pageDescription,
    };

    window.metrics.init();
    window.metrics.view(payload);
  }
};

const { pageData: props } = getClientPageData();

const { app } = createApp(props);
app.mount('#app');
initMetrics();
